import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const SemanticSearchDrawerContentAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "semantic-search-drawer-content" */ './semantic-search-drawer-content'),
  componentName: 'SemanticSearchDrawerContent',
});
